import React, { useMemo, useState } from "react";
import { Button, Input, Table } from "antd";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { getPurchaseHistoryColumns } from "./columns";

const matchesSearch = (item, query) =>
   Object.values(item).some(
      (value) => value && value.toString().toLowerCase().includes(query)
   );

const PurchaseHistory = ({
   history = [],
   isLoading,
   isDownloadingAll,
   onDownloadAll,
   onDownloadItem,
   onRefundItem
}) => {
   const [searchText, setSearchText] = useState("");

   const filteredHistory = useMemo(() => {
      const query = searchText.trim().toLowerCase();
      if (!query) return history;
      return history.filter((item) => matchesSearch(item, query));
   }, [history, searchText]);

   const columns = useMemo(
      () => getPurchaseHistoryColumns({ onDownloadItem, onRefundItem }),
      [onDownloadItem, onRefundItem]
   );

   // Nothing to zip up unless at least one transaction succeeded — guard the
   // bulk download against an empty list or a list of only failed/refunded rows.
   const hasDownloadable = useMemo(
      () => history.some((item) => String(item.status).toLowerCase() === "success"),
      [history]
   );

   return (
      <div className="funds__history">
         <div className="funds__history-header">
            <h2 className="funds__history-title">Purchase History</h2>
            <Button
               type="default"
               className="defaultButton funds__download-all"
               icon={<DownloadOutlined />}
               onClick={onDownloadAll}
               loading={isDownloadingAll}
               disabled={!hasDownloadable}
            >
               Download all
            </Button>
         </div>

         <Input
            className="funds__search"
            placeholder="Search something here"
            suffix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
         />

         <Table
            bordered
            prefixCls="table-section"
            rowClassName={() => "custom-row-border"}
            dataSource={filteredHistory}
            columns={columns}
            loading={isLoading}
            rowKey="key"
            scroll={{ x: 900 }}
            pagination={{
               position: ["bottomRight"],
               pageSize: 10,
               showSizeChanger: false
            }}
         />
      </div>
   );
};

export default React.memo(PurchaseHistory);
